import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, FadeUp, MaskLines } from "./Reveal";
import { IMG } from "@/data/content";

export const AboutSplit = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} data-testid="about-section" className="bg-white py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
            <motion.img style={{ y, scale: 1.25 }} src={IMG.team} alt="Trentvale nurse in scrubs" className="absolute inset-0 h-full w-full object-cover object-top" />
          </div>
          <div className="absolute -bottom-6 -right-2 sm:-right-6 bg-[#0A192F] text-white rounded-2xl p-6 w-48">
            <p className="text-4xl font-extrabold tracking-tight">[24/7]</p>
            <p className="mt-1 text-sm text-slate-300">local clinical on-call, never a call centre</p>
          </div>
        </div>
        <div className="lg:col-span-7 lg:pl-8">
          <Eyebrow>About Trentvale</Eyebrow>
          <MaskLines className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-[-0.04em] leading-[0.95] text-[#0A192F]"
            lines={["Rooted by the Trent.", <>Run by <span className="font-serif-i font-normal tracking-normal text-sky-700">nurses.</span></>]} />
          <FadeUp delay={0.1}>
            <p className="mt-8 text-slate-600 text-base md:text-lg leading-relaxed max-w-xl">
              Trentvale was built on a simple idea borrowed from the best agencies in the country: put clinicians in charge. Our coordinators know the wards, the care homes and the villages — so every booking is matched by someone who has done the job.
            </p>
          </FadeUp>
          <FadeUp delay={0.2} className="mt-10 grid grid-cols-3 gap-6 border-t border-slate-200 pt-8 max-w-xl">
            {[["[6]", "counties"], ["[100+]", "clinicians"], ["[98%]", "fill rate"]].map(([n, l]) => (
              <div key={l} data-testid={`about-stat-${l.replace(/\s/g, "-")}`}>
                <p className="text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A192F]">{n}</p>
                <p className="mt-1 text-sm text-slate-500">{l}</p>
              </div>
            ))}
          </FadeUp>
          <FadeUp delay={0.3}>
            <Link to="/about" data-testid="btn-about-more" className="mt-10 inline-flex items-center gap-2 font-semibold text-[#0A192F] border-b-2 border-sky-500 pb-1 hover:text-sky-700 transition-colors">Our story & standards</Link>
          </FadeUp>
        </div>
      </div>
    </section>
  );
};
